import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFilter } from '../../hooks'
import { sendStaffAppMetaData } from '../../eventTriggers'

export const FamilyMembers = () => {
  const { family_members, config } = useSelector(state=>state)
  const [ filter, setFilter, Input ] = useFilter()
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "familyMember",
        resource
      }
    })
    sendStaffAppMetaData(config.tab_default_meta_data.find(tab=>tab.detail == 'family_members').modal)
  }

  return(
    <>
      <Input {...{ filter, setFilter }}/>
      {
        family_members.filter(family_member=>((family_member.name || '').toLowerCase().includes(filter.toLowerCase()))).map(family_member=>(
          <div key={family_member.id} onClick={()=>handleClick(family_member)} className="p-4 border-bottom clickable">
            <div className="d-flex justify-content-between align-items-center">
              <b>{ family_member.name }</b>
            </div>
            <div className="text-secondary pt-1">{ family_member.relationship }</div>
          </div>
        ))
      }
    </>
  )
}